export default class MultistepForm {
    disabledClass = 'msf-disabled'

    constructor($element) {
        this.bindEvents()
    }

    bindEvents = () => {
        const { onSubmit } = this

        $(window).on('multistep-form-submit', (e, idx) => {
            onSubmit(idx)
        })
    }

    onSubmit = idx => {
        const { disabledClass, scrollTo } = this
        const disabledStep = $(`[data-msf-trigger="${idx}"]`)
        const enabledStep = $(`[data-msf-section="${idx}"]`)

        disabledStep
            .find('button, input')
            .each(function() {
                $(this)
                    .attr('disabled', 'disabled')
                    .addClass(disabledClass)
            })

        enabledStep.slideDown({
            start: function() {
                $(this).css({
                    display: $(this).attr('data-msf-flex') === '1'
                        ? 'flex'
                        : 'block'
                })
            },
            complete: function() {
                scrollTo($(this))
            }
        })
    }

    scrollTo = $el => {
        $('html,body').animate({
            scrollTop: $el.offset().top - (window.outerHeight / 7)
        }, 500);
    }
}
